var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('v-main',[(!_vm.$route.meta.beforeLogin)?[_c('mobile-header'),_c('side-nav')]:_vm._e(),_c('router-view')],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }